export const featurePageMapping: { [key: string]: PageMapping } = {
	"/events": {
		actions: [],
		buttons: [],
		icon: "home",
		label: "EVENTS",
		labelKey: "nav.events.module.label",
		nav: false,
		title: ""
	},
	"/events/tasks": {
		actions: [],
		buttons: [],
		label: "Task Mode",
		labelKey: "nav.events.taskMode.label",
		icon: "task",
		nav: true,
		title: "Task Mode",
		titleKey: "nav.events.taskMode.title"
	},
	"/events/tasks/.+": {
		actions: [],
		buttons: [],
		icon: "task",
		identifier: true,
		label: "Task Detail",
		labelKey: "nav.events.taskDetail.label",
		nav: false,
		title: "Task Detail",
		titleKey: "nav.events.taskDetail.title"
	},
	"/events/jobs": {
		actions: [],
		buttons: [],
		label: "Job Mode",
		labelKey: "nav.events.jobMode.label",
		icon: "qr_code_scanner",
		nav: true,
		title: "Job Mode",
		titleKey: "nav.events.jobMode.title"
	},
	"/events/jobs/.+/tasks/.+": {
		actions: [],
		buttons: [],
		icon: "task",
		identifier: true,
		label: "Task Detail",
		labelKey: "nav.events.taskDetail.label",
		nav: false,
		title: "Task Detail",
		titleKey: "nav.events.taskDetail.title"
	},
	"/events/jobs/.+": {
		actions: [],
		buttons: [],
		icon: "qr_code_scanner",
		identifier: true,
		label: "Job Cost Center",
		labelKey: "nav.events.jobCostCenter.label",
		nav: false,
		title: "Job Cost Center",
		titleKey: "nav.events.jobCostCenter.title"
	},
	"/events/history": {
		actions: [],
		buttons: [],
		icon: "history",
		label: "History",
		labelKey: "nav.events.history.label",
		nav: true,
		title: "History",
		titleKey: "nav.events.history.title"
	}
};

export const flatPageMapping: { [key: string]: PageMapping } = {
	...featurePageMapping
};
